import React from "react";
import { string, bool, shape, number } from "prop-types";
import I18n from "pages/_components/I18n";
import EditableLabel from "pages/_components/fields/EditableLabel";
import { actions as productsActions } from "reducers/products";
import { useDispatch } from "react-redux";
import * as i18n from "util/i18n";

const ProductInfo = (props) => {
    const dispatch = useDispatch();
    const { isDesktop, account } = props;
    const { productAlias, blocked, idProduct } = account;
    const handleSave = (alias) => dispatch(productsActions.changeProductAlias(alias, idProduct));
    return (
        <>
            <EditableLabel isDesktop={isDesktop} onSave={handleSave} value={productAlias}>
                <h1 className="title-content">{productAlias || i18n.get("accounts.accountLabel.alias")}</h1>
            </EditableLabel>
            {blocked === "S" && (
                <span className="tag">
                    <I18n id="accounts.accountStatus.Blocked" />
                </span>
            )}
        </>
    );
};

ProductInfo.propTypes = {
    account: shape({
        idEnvironment: number,
        idProduct: string,
        productType: string.isRequired,
        productAlias: string,
        label: string,
        shortLabel: string,
        extraInfo: string,
        ownerName: string,
        currency: string.isRequired,
        extraInfoMarked: string,
        isOperative: bool,
    }),
    isDesktop: bool.isRequired,
};

ProductInfo.defaultProps = {
    account: { productAlias: "", extraInfoMasked: "", blocked: "" },
};

export default ProductInfo;
